import React, {useEffect, useMemo, useRef} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {
    ACTIONS,
    getPartRefs,
    getTemplateTranslation,
    getUserResourcesByPartRef, resourceIsComplete
} from "../../../../Providers/TemplateInstanceProvider";
import i18next from 'i18next';
import Icon from "@material-ui/core/Icon";

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: '#929292',
        paddingTop: '12px',
        paddingBottom: '12px',
        flexWrap: 'nowrap',
        overflow: 'auto',
        position: 'fixed',
        left: 0,
        bottom: '208px',
        width: '100%',
        display: 'flex',
        '&::before, &::after':  {
            content: '""',  /* Insert pseudo-element */
            margin: 'auto'
        },
    },
    partRefButton: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.getContrastText(theme.palette.primary.main),
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingRight: '12px', // This looks better, probably because of the circle?
        paddingLeft: theme.spacing(2),
        position: 'relative',
        border: 'none',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        '& span': {
            marginLeft: theme.spacing(1),
            fontSize: '14px'
        },
        '&.selected': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.getContrastText(theme.palette.secondary.main),
        }
    },
    rootPlaceholder: {
        paddingTop: '12px',
        paddingBottom: '12px',
        opacity: 0,
        button: {

        }
    },
    partRefComplete: {
        position: 'absolute',
        right: '-8px',
        bottom: '-8px',
        backgroundColor: 'green',
        width: '15px',
        height: '15px',
        transform: 'rotate(45deg)'
    }
}))

export default () => {
    const classes = useStyles();
    const [state, dispatch] = useTemplateInstance();

    const partRefs = getPartRefs(state.template);

    if (partRefs.length == 1) {
        return null;
    }

    const setPartRef = (id) => {
        dispatch({
            type: ACTIONS.SET_CURRENT_PARTREF,
            partRefId: id
        })
    }

    return <>
        <div className={classes.rootPlaceholder}><button className={classes.partRefButton}>Text</button></div>
        <div className={classes.root}>
        {partRefs.map(partRef => {
            return <PartRefButton resources={state.resources} partRef={partRef} key={partRef.id}
                                  isSelected={state.currentPartRefId == partRef.id} onClick={setPartRef}/>
        })}
    </div>
        </>
}

const PartRefButton = ({resources, partRef, isSelected, onClick}) => {
    const [state, dispatch] = useTemplateInstance();
    const ref = useRef();
    const classes = useStyles();

    useEffect(() => {
        if (ref.current && isSelected) {
            const width = window.innerWidth;
            const size = ref.current.getBoundingClientRect();

            const left = ref.current.offsetLeft - (width/2) + (size.width / 2)
            console.log('Scroll to left', ref.current.offsetLeft, left, width, size);
            // FIXME: Parent parent? Wtf? scrollIntoView scroll window also, not good:
            ref.current.parentNode.scrollLeft = left;
        }
    }, [])

    // Only update complete status if resources changed:
    const partRefIsComplete = useMemo(() => {
        const resources = getUserResourcesByPartRef(partRef, state);
        for (const resource of resources) {
            if (!resourceIsComplete(resource)) {
                return false;
            }
        }
        return true;
    }, [resources]);

    return <button ref={ref} className={`${classes.partRefButton} ${isSelected ? 'selected' : ''}`} key={partRef.id}
                   onClick={() => onClick(partRef.id)}>
        {getTemplateTranslation(partRef.descriptions, i18next.language)}
        {partRefIsComplete ? <Icon>check_circle_outline</Icon> : <Icon>radio_button_unchecked</Icon>}
    </button>
}